module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable16.ca73b29c.jpg";